import 'css-chunksrc/client/scenes/event/participantsList/styles.scss';export default {
  "participantsList": "_participantsList_kikwj_1",
  "root": "_root_kikwj_8",
  "list": "_list_kikwj_12",
  "main": "_main_kikwj_19",
  "summary": "_summary_kikwj_26",
  "menu": "_menu_kikwj_35",
  "addParticipantIcon": "_addParticipantIcon_kikwj_39",
  "resourcesList": "_resourcesList_kikwj_45",
  "quickParticipantMenu": "_quickParticipantMenu_kikwj_52",
  "overlay": "_overlay_kikwj_60",
  "participants": "_participants_kikwj_1",
  "participant": "_participant_kikwj_1"
};